import { render } from "./TheHeadersider.vue?vue&type=template&id=edef699a"
import script from "./TheHeadersider.vue?vue&type=script&lang=js"
export * from "./TheHeadersider.vue?vue&type=script&lang=js"

import "./TheHeadersider.vue?vue&type=style&index=0&id=edef699a&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__